<template>
  <BaseFrame
    submit-text="提交"
    clear-text=""
    :submit-loading="submitLoading"
    @submit="submitCuringResult"
    @cancel="handleToCuringList" >
    <div slot="content">
      <lk-card title="养护明细信息">
        <lk-form :label-width="120" label-position="right">
          <lk-row :gutter="16">
            <lk-col span="20">
              <lk-form-item label="养护结果:">
                <lk-radio-group v-model="curingResultType">
                  <lk-radio :label="1">商品全部正常(存储条件、包装质量、外观质量、养护结果)</lk-radio><br/>
                  <lk-radio :label="2">存在存疑的商品</lk-radio>
                </lk-radio-group>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row :gutter="16">
            <lk-col span="22">
              <lk-form-item label="选择商品:">
                <lk-button type="primary" class="mb16" @click="showDoubtfulModal" :disabled="curingResultType === 1">可疑商品</lk-button>
                <div class="requireBreakAdd cancelTableShadow" v-show="curingResultType !== 1">
                  <lk-table
                    border
                    :columns="doubtfulColumns"
                    :data="doubtfulTableData">
                  </lk-table>
                </div>
              </lk-form-item>
            </lk-col>
          </lk-row>
        </lk-form>
      </lk-card>
      <lk-modal
        v-model="goodsModalVisiable"
        title="添加商品"
        width="900"
        @on-cancel="handleSelectCancel">
        <div class="queryContainer">
          <div class="queryItem">
            <label>关键词:</label>
            <lk-input
              class="item"
              :maxlength="100"
              placeholder="商品编码、助记码、商品名称、通用名称"
              clearable
              v-model.trim="modalQueryParams.nameMix">
            </lk-input>
          </div>
          <div class="queryItem">
            <lk-button type="primary" class="mr8" @click="getModalDataList">查询</lk-button>
            <lk-button @click="handleModalReset" class="mr8">重置</lk-button>
          </div>
        </div>
        <div style="position: relative;">
          <loading v-show="modalLoading"></loading>
          <lk-table
            border
            :columns="modalColumns"
            :data="modalTableData"
            @on-selection-change="handleModalSelection">
          </lk-table>
        </div>
        <div slot="footer">
          <div class="queryItem">
            <span class="mr8">已选:{{this.modalSelection.length}}项</span>
            <lk-button @click="handleSelectCancel">取消</lk-button>
            <lk-button type="primary" class="mr" @click="confirmDoubtfulGoods">确定</lk-button>
          </div>
        </div>
      </lk-modal>
    </div>
  </BaseFrame>
</template>
<script>
import BaseFrame from '../../components/frame/BaseFrame';
import inventory from '../../services/inventory';
import CuringResultExpand from './CuringResultExpand.vue';
import utils from '../../libs/utils';
import loading from '../../components/LoadingSpan.vue';

export default {
  name: 'curingResult',
  components: {
    BaseFrame,
    loading,
  },
  data() {
    return {
      submitLoading: false,
      modalLoading: false,
      modalQueryParams: {
        nameMix: null,
      },
      curingResultType: 1,
      doubtfulColumns: [
        {
          type: 'expand',
          width: 46,
          render: (h, { row }) => h(CuringResultExpand,
            {
              props: {
                row,
              },
            }),
        },
        { title: '商品编码', key: 'drugSerialCode', minWidth: 110 },
        { title: '通用名称', key: 'approvedDrugNames', minWidth: 110 },
        { title: '规格', key: 'specifications', minWidth: 110 },
        { title: '单位', key: 'drugMiniPackageUnit', minWidth: 110 },
        { title: '数量', key: 'inventoryCount', minWidth: 110 },
        { title: '批号', key: 'goodsBatchNumber', minWidth: 110 },
        { title: '仓库', key: 'warehouseName', minWidth: 110 },
        { title: '货位', key: 'locationCode', minWidth: 110 },
        {
          title: '存疑数量',
          key: 'doubtfulCount',
          minWidth: 130,
          fixed: 'right',
          render: (h, { row, index }) => h('lk-input-number', {
            props: {
              clearable: true,
              value: row.doubtfulCount,
              min: 0.01,
              max: 1000000000,
              precision: 2,
              activeChange: false,
            },
            on: {
              'on-change': (value) => {
                row.doubtfulCount = value;
                setTimeout(() => {
                  this.doubtfulTableData[index].doubtfulCount = value;
                });
              },
            },
          }),
        },
        {
          title: '备注',
          key: 'description',
          minWidth: 130,
          fixed: 'right',
          render: (h, { row, index }) => h('lk-input', {
            props: {
              // clearable: true,
              value: row.description,
              maxlength: 50,
            },
            on: {
              'on-blur': (e) => {
                const value = e.target.value;
                row.description = value;
                setTimeout(() => {
                  this.doubtfulTableData[index].description = value;
                });
              },
            },
          }),
        },
        {
          title: '操作',
          key: 'delBtn',
          minWidth: 100,
          fixed: 'right',
          render: (h, { index }) => h('div', [
            h('lk-button', {
              props: {
                type: 'text',
              },
              on: {
                click: () => {
                  this.doubtfulTableData.splice(index, 1);
                },
              },
            }, '删除'),
          ]),
        },
      ],
      doubtfulTableData: [],
      modalTableData: [],
      modalColumns: [
        { type: 'selection', width: 60 },
        { title: '商品编码', key: 'drugSerialCode', minWidth: 110 },
        { title: '商品名称', key: 'goodsName', minWidth: 110 },
        { title: '通用名称', key: 'approvedDrugNames', minWidth: 110 },
        { title: '规格', key: 'specifications', minWidth: 110 },
        { title: '剂型', key: 'dosageForm', minWidth: 110 },
        { title: '生产厂家', key: 'manufacturer', minWidth: 110 },
        { title: '商品状态', key: 'goodsStoreStatusStr', minWidth: 110 },
        { title: '单位', key: 'drugMiniPackageUnit', minWidth: 110 },
        { title: '仓库', key: 'warehouseName', minWidth: 110 },
        { title: '货位', key: 'locationCode', minWidth: 110 },
        { title: '数量', key: 'inventoryCount', minWidth: 110 },
        { title: '批次', key: 'goodsBatchSeq', minWidth: 110 },
        { title: '批号', key: 'goodsBatchNumber', minWidth: 110 },
        { title: '供应商', key: 'supplierName', minWidth: 110 },
      ],
      modalSelection: [],
      goodsModalVisiable: false,
      statusMap: new Map([
        [1, '启用'],
        [2, '禁用'],
      ]),
      curingResults: [],
      curingIdList: [],
    };
  },
  computed: {
    selectedDoubtfulIds() {
      const result = [];
      this.doubtfulTableData.forEach((item) => {
        result.push(item.inventoryId);
      });
      return result;
    },
    selectedTempGoodsIds() {
      const result = [];
      this.modalSelection.forEach((item) => {
        result.push(item.inventoryId);
      });
      return result;
    },
  },
  methods: {
    showDoubtfulModal() {
      this.modalSelection = utils.deepClone(this.doubtfulTableData);
      this.goodsModalVisiable = true;
      this.getModalDataList();
    },
    getModalDataList() {
      const curingIds = this.curingIdList;
      const params = {};
      params.curingIds = curingIds;
      if (this.modalQueryParams.nameMix) {
        params.nameMix = this.modalQueryParams.nameMix;
      }
      this.$store.commit('setDisableLoading', true);
      this.modalLoading = true;
      inventory.curingRecordGoodsList(params).then((res) => {
        if (res.data.status === 200) {
          const { list } = res.data.data;
          list.forEach((item) => {
            item.goodsStoreStatusStr = this.statusMap.get(item.goodsStoreStatus);
            // 选中已经选中的，避免重复选中
            item._checked = this.selectedDoubtfulIds.includes(item.inventoryId) || this.selectedTempGoodsIds.includes(item.inventoryId);
            item._disabled = this.selectedDoubtfulIds.includes(item.inventoryId);
          });
          this.modalTableData = list;
        } else {
          this.$Message.error(res.data.error);
        }
        this.modalLoading = false;
      }).catch((err) => {
        this.modalLoading = false;
        utils.handleError(err);
      });
    },
    getCuringData() {
      const ids = this.curingIdList;
      const params = {
        ids,
        page: 1,
        size: ids.length,
      };
      this.curingResults = [];
      inventory.curingList(params).then((res) => {
        if (res.data.status === 200) {
          res.data.data.list.forEach((item) => {
            const result = {};
            result.curingId = item.id;
            this.curingResults.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleModalReset() {
      this.modalQueryParams = {};
    },
    handleSelectCancel() {
      this.hideModal();
      this.handleModalReset();
    },
    hideModal() {
      this.goodsModalVisiable = false;
      this.modalTableData = [];
    },
    handleModalSelection(selection) {
      const result = [];
      selection.forEach((item) => {
        if (!this.selectedDoubtfulIds.includes(item.inventoryId)) {
          item.doubtfulCount = 0;
          item.description = null;
          result.push(item);
        }
      });
      const oldData = utils.deepClone(this.doubtfulTableData);
      this.modalSelection = [...oldData, ...result];
    },
    confirmDoubtfulGoods() {
      if (this.modalSelection.length === 0) {
        this.$Message.error('请选择商品');
      }
      this.doubtfulTableData = utils.deepClone(this.modalSelection);
      this.hideModal();
    },
    submitCuringResult() {
      const curingDoubtfuls = [];
      if (this.curingResultType === 2) {
        const len = this.doubtfulTableData.length;
        if (len === 0) {
          this.$Message.error('请添加存疑商品');
          return;
        }

        let errorMsg = '';
        for (let i = 0; i < len; i++) {
          const item = this.doubtfulTableData[i];
          if (item.inventoryCount === 0) {
            errorMsg = `商品编号: ${item.drugSerialCode}的库存数量为0，无法提交`;
            break;
          }
          if (!item.doubtfulCount) {
            errorMsg = `商品编号: ${item.drugSerialCode}的存疑数量必须大于0`;
            break;
          }
          if (item.doubtfulCount > item.inventoryCount) {
            errorMsg = `商品编号: ${item.drugSerialCode}的存疑数量不能超过库存数量`;
            break;
          }
          if (!item.description) {
            errorMsg = `商品编号: ${item.drugSerialCode}的备注不能为空`;
            break;
          }
          const param = {
            curingId: item.curingId,
            inventoryId: item.inventoryId,
            count: item.doubtfulCount,
            description: item.description,
          };
          curingDoubtfuls.push(param);
        }

        if (errorMsg) {
          this.$Message.error(errorMsg);
          return;
        }
      }

      const params = {};
      if (this.curingResultType === 2) {
        params.curingDoubtfuls = curingDoubtfuls;
      } else {
        params.curingResults = this.curingResults; // 之前的记录
      }

      this.submitLoading = true;
      inventory.addCuringRecord(params).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success({
            content: '提交成功',
            duration: 10,
            closable: true,
          });
          this.handleToCuringList();
        } else {
          this.$Message.error(res.data.error);
        }
        this.submitLoading = false;
      }).catch((err) => {
        this.submitLoading = false;
        utils.handleError(err);
      });
    },
    handleToCuringList() {
      this.$router.push({
        name: 'curingList',
      });
    },
  },
  created() {
    // 兼容地址栏和本地存储传参
    if (this.$route.params.ids) {
      this.curingIdList = this.$route.params.ids.split(',');
    } else {
      this.curingIdList = window.sessionStorage.getItem('curingRecordIds').split(',');
    }
    this.getCuringData();
  },
};
</script>
<style lang="less" scoped>
</style>
